var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCaretBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0199 6.11785L0.412892 2.73406C-0.464487 1.91098 0.148291 0.5 1.38776 0.5H8.6018C9.84123 0.5 10.4679 1.91098 9.59054 2.73406L5.98355 6.11785C5.44041 6.62738 4.56305 6.62738 4.0199 6.11785Z",
    fill: "#003399"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaretBlue);
export default __webpack_public_path__ + "static/media/IconCaretBlue.c2b08fdd74b6afd6efbcbb375057d55a.svg";
export { ForwardRef as ReactComponent };